export class TaskDocument
{
    id: string|undefined;
    active: boolean;
    obligatoire: boolean;
    code:string;
    label:string;
    description:string;
    taskWorkflowByProfileId:string;
}